<template>
  <v-container
      fluid
      grid-list-md
      style="padding: 16px 24px 10px 24px;"
      v-if="readyToUse"
  >
    <v-col
        cols="8"
        md="6"
        style="padding-left:0px; padding-top: 10px; padding-bottom: 10px;"
    >
      <span class="headline font-weight-light">
        Naslovnica
        <v-icon
            slot="divider"
            @click="reloadAllData()"
            style="padding-bottom: 2px;"
        >mdi-refresh</v-icon
        >
      </span>
    </v-col>
    <template v-if="[1, 7].includes(activeRole.role_id)">
      <v-row class="ma-5 justify-center">
        <v-card>
          <v-card-title class="primary white--text">Ukupan broj izdanih potvrda o školovanju</v-card-title>
          <v-card-text class="mt-3 justify-center d-flex"><h1 class="display-3">{{number_of_certificates}}</h1></v-card-text>
        </v-card>
      </v-row>
    </template>
    <template v-if="[1, 2, 3].includes(activeRole.role_id)">
      <v-row>
        <template v-for="(item, key, i) in stavke">
          <v-col
              cols="12"
              md="3"
              v-if="
              key !== 'maleFemaleRatio' && key !== 'issueIdentityCount' && i < 4
            "
              :key="i"
          >
            <v-card outlined class="px-3">
              <v-row>
                <v-col cols="4">
                  <div
                      style="background-color: #004379; border-radius: 4px"
                      class="text-center py-4"
                  >
                    <v-icon size="32" color="white">{{ item.icon }}</v-icon>
                  </div>
                </v-col>
                <v-col cols="8">
                  <div class="text-h5 font-weight-bold">{{ item.count }}</div>
                  <div class="grey--text">{{ item["text"] }}</div>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </template>
      </v-row>
<!--      <v-row>-->
<!--        <v-col class="3" cols="12">-->
<!--          <v-card outlined class="px-4">-->
<!--            <div class="grey&#45;&#45;text pt-5 pl-5">Broj dodijeljenih identiteta</div>-->
<!--            <div>-->
<!--              <apexchart-->
<!--                  ref="loginCountChart"-->
<!--                  type="line"-->
<!--                  height="350"-->
<!--                  :options="chartOptions2"-->
<!--                  :series="series2"-->
<!--              ></apexchart>-->
<!--            </div>-->
<!--          </v-card>-->
<!--        </v-col>-->
<!--      </v-row>-->
    </template>

    <v-row v-if="[1,2,3,4,5,8,15].includes(activeRole.role_id)">
      <v-col cols="12" md="4">
        <v-card outlined class="px-3" height="100%">
          <div class="grey--text pt-5 pl-5">Odnos muških i ženskih učenika</div>
          <!--                        <doughnut-chart  :chart-data="datacollection"></doughnut-chart>-->
          <div>
            <apexchart
                ref="maleFemaleRatioChart"
                v-if="showDonut"
                class="pt-10"
                type="donut"
                width="100%"
                :options="chartOptions3"
                :series="series3"
            ></apexchart>
          </div>
          <div class="grey--text  pl-5 pt-15 pb-5">
          </div>
        </v-card>
      </v-col>

      <v-col cols="12" md="4">
        <v-card outlined class="px-3" height="100%">
          <div class="grey--text pt-5 pl-5 ">
           Ukupan broj upisanih ocjena
          </div>
          <div class="chart-wrapper">
            <apexchart
                height="350"
                width="100%"
                type="bar"
                :options="options"
                :series="series"
            >
            </apexchart>
          </div>
          <div class="grey--text  pl-5 pb-5">
          </div>
        </v-card>
      </v-col>

      <v-col cols="12" md="4">
        <v-card outlined class="px-3" height="100%">
          <div class="grey--text pt-5 pl-5 ">
           Broj učenika s određenim uspjehom
          </div>
          <div class="chart-wrapper">
            <apexchart
                    height="350"
                    width="100%"
                    type="bar"
                    :options="options9"
                    :series="series9"
            >
            </apexchart>
          </div>
          <div class="grey--text  pl-5 pb-5">
          </div>
        </v-card>
      </v-col>
    </v-row>

    <template v-if="[1,2,3,4,5,8,15].includes(activeRole.role_id)">
      <v-row>
        <v-col cols="12" md="12">
          <v-card outlined class="px-3" height="100%">
            <div class="grey--text pt-5 pl-5">
              Odnos opravdanih i neopravdanih sati
            </div>
            <div>
              <apexchart
                      height="350"
                      width="100%"
                      type="bar"
                      :options="chartOptions1"
                      :series="series1"
              ></apexchart>
            </div>
            <div class="grey--text  pl-5 pb-5">

            </div>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="4">
          <v-card outlined class="px-3" height="100%">
            <div class="grey--text pt-5 pl-5">Vladanje učenika</div>

            <div class="chart-wrapper">
              <apexchart
                  height="350"
                  width="100%"
                  type="bar"
                  :options="options4"
                  :series="series4"
              >
              </apexchart>
            </div>
          </v-card>
        </v-col>
        <v-col cols="12" md="4">
          <v-card outlined class="px-3" height="100%">
            <div class="grey--text pt-5 pl-5">
              Broj izrečenih pedagoških mjera
            </div>

            <div class="chart-wrapper">
              <apexchart
                      height="350"
                      width="100%"
                      type="bar"
                      :options="options6"
                      :series="series6"
              >
              </apexchart>
            </div>
          </v-card>
        </v-col>


<!--        <v-col cols="12" md="4">-->
<!--          &lt;!&ndash;             v-for="item in items"&ndash;&gt;-->
<!--          &lt;!&ndash;             :key="item"&ndash;&gt;-->

<!--          <v-card outlined class="px-3" height="100%">-->
<!--            <div class="grey&#45;&#45;text pt-5 pl-5">Statistika odjela</div>-->

<!--            <v-divider></v-divider>-->

<!--            &lt;!&ndash;          <v-list dense>&ndash;&gt;-->

<!--            &lt;!&ndash;            <v-list-item&ndash;&gt;-->

<!--            &lt;!&ndash;                    v-for="(key, index) in filteredKeys"&ndash;&gt;-->
<!--            &lt;!&ndash;                    :key="index"&ndash;&gt;-->
<!--            &lt;!&ndash;            >&ndash;&gt;-->
<!--            &lt;!&ndash;              <v-list-item-content&ndash;&gt;-->
<!--            &lt;!&ndash;                      >&ndash;&gt;-->
<!--            &lt;!&ndash;                {{ key }}&ndash;&gt;-->
<!--            &lt;!&ndash;              </v-list-item-content>&ndash;&gt;-->

<!--            &lt;!&ndash;              <v-list-item-content&ndash;&gt;-->
<!--            &lt;!&ndash;                      class="align-end"&ndash;&gt;-->
<!--            &lt;!&ndash;              >&ndash;&gt;-->
<!--            &lt;!&ndash;                {{&ndash;&gt;-->
<!--            &lt;!&ndash;                item[key.toLowerCase()]&ndash;&gt;-->
<!--            &lt;!&ndash;                }}&ndash;&gt;-->

<!--            &lt;!&ndash;              </v-list-item-content>&ndash;&gt;-->
<!--            &lt;!&ndash;            </v-list-item>&ndash;&gt;-->
<!--            &lt;!&ndash;          </v-list>&ndash;&gt;-->
<!--            <v-list dense>-->
<!--              <v-list-item>-->
<!--                <v-list-item-content>Broj učenika:</v-list-item-content>-->
<!--                <v-list-item-content class="align-end">-->
<!--                  {{ pupil_number }}-->
<!--                </v-list-item-content>-->
<!--              </v-list-item>-->

<!--              <v-list-item>-->
<!--                <v-list-item-content>Ženskih:</v-list-item-content>-->
<!--                <v-list-item-content class="align-end">-->
<!--                  {{ female }}-->
<!--                </v-list-item-content>-->
<!--              </v-list-item>-->

<!--              <v-list-item>-->
<!--                <v-list-item-content>Muških:</v-list-item-content>-->
<!--                <v-list-item-content class="align-end">-->
<!--                  {{ male }}-->
<!--                </v-list-item-content>-->
<!--              </v-list-item>-->

<!--              <v-list-item>-->
<!--                <v-list-item-content>Prosječna ocjena:</v-list-item-content>-->
<!--                <v-list-item-content class="align-end">-->
<!--                  {{ average_grade }}-->
<!--                </v-list-item-content>-->
<!--              </v-list-item>-->
<!--              <v-divider></v-divider>-->
<!--              <v-list-item>-->
<!--                <v-list-item-content>Prolazi učenika:</v-list-item-content>-->
<!--                <v-list-item-content class="align-end">-->
<!--                  {{ passes_pupils }}-->
<!--                </v-list-item-content>-->
<!--              </v-list-item>-->

<!--              <v-list-item>-->
<!--                <v-list-item-content>Prolaznost %:</v-list-item-content>-->
<!--                <v-list-item-content class="align-end">-->
<!--                  {{ transience }}-->
<!--                </v-list-item-content>-->
<!--              </v-list-item>-->

<!--              <v-list-item>-->
<!--                <v-list-item-content>Pada učenika:</v-list-item-content>-->
<!--                <v-list-item-content class="align-end">-->
<!--                  {{ falling_pupils }}-->
<!--                </v-list-item-content>-->
<!--              </v-list-item>-->

<!--              <v-list-item>-->
<!--                <v-list-item-content>Pada učenika %:</v-list-item-content>-->
<!--                <v-list-item-content class="align-end">-->
<!--                  {{ fall }}-->
<!--                </v-list-item-content>-->
<!--              </v-list-item>-->
<!--              <v-divider></v-divider>-->

<!--              <v-list-item>-->
<!--                <v-list-item-content>Uk. sati izostanka:</v-list-item-content>-->
<!--                <v-list-item-content class="align-end">-->
<!--                  {{ absences }}-->
<!--                </v-list-item-content>-->
<!--              </v-list-item>-->

<!--              <v-list-item>-->
<!--                <v-list-item-content>Opravdano sati:</v-list-item-content>-->
<!--                <v-list-item-content class="align-end">-->
<!--                  {{ justified }}-->
<!--                </v-list-item-content>-->
<!--              </v-list-item>-->

<!--              <v-list-item>-->
<!--                <v-list-item-content>Neopravdano sati:</v-list-item-content>-->
<!--                <v-list-item-content class="align-end">-->
<!--                  {{ unjustified }}-->
<!--                </v-list-item-content>-->
<!--              </v-list-item>-->
<!--            </v-list>-->
<!--            <div></div>-->
<!--            <div class="grey&#45;&#45;text  pl-5 pb-5">-->
<!--              U tablici su prikazani testni podaci.-->
<!--            </div>-->
<!--          </v-card>-->
<!--        </v-col>-->
<!--        <v-col cols="12" md="4">-->
<!--          <v-card outlined class="px-3" height="100%">-->
<!--            <div class="grey&#45;&#45;text pt-5 pl-5 ">-->
<!--              Broj učenika s negativnim ocjenama-->
<!--            </div>-->
<!--            <div class="chart-wrapper">-->
<!--              <apexchart-->
<!--                      height="350"-->
<!--                      width="100%"-->
<!--                      type="bar"-->
<!--                      :options="options5"-->
<!--                      :series="series5"-->
<!--              >-->
<!--              </apexchart>-->
<!--            </div>-->
<!--            <div class="grey&#45;&#45;text  pl-5 pb-5">-->
<!--              U grafu su prikazani testni podaci. Za svaku školsku godinu, na-->
<!--              polugodištu i na kraju školske godine biti će prikazani-->
<!--              odgovarajući podaci.-->
<!--            </div>-->
<!--          </v-card>-->
<!--        </v-col>-->


<!--        <v-col cols="12" md="4">-->
<!--          <v-card outlined class="px-3" height="100%">-->
<!--            <div class="grey&#45;&#45;text pt-5 pl-5 ">-->
<!--              Broj dodjeljenih pohvala učenicima-->
<!--            </div>-->
<!--            <div class="chart-wrapper">-->
<!--              <apexchart-->
<!--                  height="350"-->
<!--                  width="100%"-->
<!--                  type="bar"-->
<!--                  :options="options7"-->
<!--                  :series="series7"-->
<!--              >-->
<!--              </apexchart>-->
<!--            </div>-->
<!--            <div class="grey&#45;&#45;text  pl-5 pb-5">-->
<!--              U grafu su prikazani testni podaci. Za svaku školsku godinu, na-->
<!--              pologodištu i na kraju školske godine biti će prikazani-->
<!--              odgovarajući podaci.-->
<!--            </div>-->
<!--          </v-card>-->
<!--        </v-col>-->

        <v-col cols="12" md="4">
          <!--             v-for="item in items"-->
          <!--             :key="item"-->

          <v-card outlined class="px-3" height="100%">
            <div class="grey--text pt-5 pl-5">Prolaznost učenika</div>

            <apexchart
                v-if="showDonut"
                class="pt-10"
                type="donut"
                width="100%"
                :options="chartOptions8"
                :series="series8"
            ></apexchart>

            <div></div>
<!--            <div class="grey&#45;&#45;text  pl-5 pt-15 pb-5">-->
<!--              U grafu su prikazani testni podaci. Za svaku školsku godinu, na-->
<!--              polugodištu i na kraju školske godine biti će prikazani-->
<!--              odgovarajući podaci.-->
<!--            </div>-->
          </v-card>
        </v-col>
      </v-row>
    </template>
  </v-container>
</template>

<script>
import {serverBus} from "../../main";
import ApiV2 from "../../services/ApiV2";
// import DoughnutChart from '../../plugins/DoughnutChart.js';

export default {
  components: {
    // DoughnutChart,
  },

  created: function () {
    document.title = "SUMIT matica";

    this.getData();
    if (this.activeRole.role_id === 7) {
      this.getDataForSecretary();
    }
    serverBus.$on("reload-all-data", () => {
      this.getData();
          if (this.activeRole.role_id === 7) {
            this.getDataForSecretary();
          }
    });
  },

  mounted: function () {
    // this.fillData()
  },

  methods: {
    getData() {
      serverBus.$emit("perform-layout-loading", true);

      this.series1 =  [
        {
          name: 'Neobrađeni',
          data: [],

        },
        {
          name: 'Neopravdani',
          data: [],

        }, {
          name: 'Opravdani',
          data: []
        }];
      this.series3=[];
      this.series4=   [{
        name: ['Broj učenika'],
        data: []
      }];
      this.options4.xaxis.categories = [];
      this.series6=[];
      this.options6.xaxis.categories = [];
      this.series9=  [
        {
          name: ["Broj učenika"],
          data: [],
        },
      ];

      ApiV2.get("dashboard")
          .then((response) => {
            this.stavke = response.data;

            let newDataGradeChart = [];
            for (let i = 1; i <= 5; i++) {
              let ocjena = response.data.grades.find(item => Number(item.grade_value) === i);
              if (ocjena)
                newDataGradeChart.unshift(ocjena.total);
              else
                newDataGradeChart.unshift(0)
            }
            this.series = [{
              name: "Broj ocjena",
              data: newDataGradeChart
            }]

            let SuccessValueDataChart = [];
            for (let i = 1; i <= 5; i++){
              let zakljucnaOcjena = response.data.certainSuccess.find(item => Number(item.success_value) === i);
              if(zakljucnaOcjena)
                SuccessValueDataChart.unshift(zakljucnaOcjena.total);
              else
                SuccessValueDataChart.unshift(0)
            }

            this.series9 = [{
                name: "Broj učenika",
                data: SuccessValueDataChart
              }]

            let ConductValueDataChart = [];
            let ConductTitleDataChart = [];
            for (let i = 1; i <= 5; i++) {
              let vladanje = response.data.conduct.find(item => Number(item.conduct_value) === i);
              if (vladanje){
                ConductValueDataChart.unshift(vladanje.total);
                ConductTitleDataChart.unshift(this.conductTitles[i]);
              }
            }

            this.series4 = [{
              name: "Broj učenika",
              data: ConductValueDataChart
            }]
            this.options4.xaxis.categories.push(...ConductTitleDataChart)

            // PEDAGOŠKE MJERE

            let pedagogicalMeasureData = response.data.pedagogicalMeasure || [];

            let PedagogicalValueDataChart = pedagogicalMeasureData.map(item => item.total || 0);
            let PedagogicalTitleDataChart = pedagogicalMeasureData.map(item => item.pedagogical_measure_title);

            this.options6.xaxis.categories = this.options6.xaxis.categories.concat(PedagogicalTitleDataChart.filter(title => !this.options6.xaxis.categories.includes(title)));

            this.series6 = [{
              name: "Broj učenika",
              data: PedagogicalValueDataChart
            }];


            //izostanci
            let absencesData = response.data.absences;
            let newAbsencesData = [
              {
                name: "Neobrađeno",
                data: []
              },
              {
                name: "Neopravdano",
                data: []
              },
              {
                name: "Opravdano",
                data: []
              }
            ];

            let months = [];
            for (const [monthNumber, monthAbsences] of Object.entries(absencesData)) {
              months.push(this.months_hr[monthNumber - 1])
              for (let i = 0; i < 3; i++) {
                newAbsencesData[i].data.push(monthAbsences[i] ? monthAbsences[i].total : 0);
              }
            }
            this.series1 = newAbsencesData
            this.chartOptions1.xaxis = {
              categories: months
            }

            this.series3[0] = this.stavke.maleFemaleRatio.males;
            this.series3[1] = this.stavke.maleFemaleRatio.females;
            this.series8[0] = this.stavke.percentagePassesRatio.prolazi;
            this.series8[1] = this.stavke.percentagePassesRatio.pada;
            this.series2[0].data = [];
            this.series2[1].data = [];
            this.series2[2].data = [];

            for (const [key, value] of Object.entries(
                response.data["issueIdentityCount"]
            )) {
              this.series2[0].data.push({x: this.$parseDate(key), y: value});
              console.log("key" + key);
            }

            for (const [key, value] of Object.entries(
                response.data["issueIdentityDatesEmployees"]
            )) {
              this.series2[1].data.push({x: this.$parseDate(key), y: value});
              console.log("key" + key);
            }

            for (const [key, value] of Object.entries(
                response.data["issueIdentityDatesPupils"]
            )) {
              this.series2[2].data.push({x: this.$parseDate(key), y: value});
              console.log("key" + key);
            }

            const self = this;
            self.showDonut = false;

            setTimeout(() => {
              self.readyToUse = true;
              this.$nextTick(() => {
                this.updateSeriesLine();
              });
              self.showDonut = true;

              serverBus.$emit("perform-layout-loading", false);
            }, 120);
          })
          // .catch(() => {
          //   serverBus.$emit("perform-layout-loading", false);
          //
          //   // serverBus.$emit(
          //   //     "show-snackbar",
          //   //     false,
          //   //     "Nemate ulogu za pregled nadzorne ploče!"
          //   // );
          // })
          .finally(() => {
          });
    },
    getDataForSecretary() {

      ApiV2.get("dashboard_for_secretary")
          .then((response) => {
            this.number_of_certificates = response.data;

          })
          .finally(() => {
          });
    },
    reloadAllData() {
      serverBus.$emit("reload-all-data");
    },

    updateSeriesLine() {
      // console.log(this.$refs.loginCountChart)
      this.$refs?.loginCountChart?.updateSeries(
          [
            {
              data: this.series2[0].data,
            },
            {
              data: this.series2[1].data,
            },
            {
              data: this.series2[2].data,
            },
          ],
          false,
          true
      );
    },
  },
  computed: {
    filteredKeys() {
      return this.keys.filter((key) => key !== "Name");
    },
    activeRole() {
      return this.$store.getters.getCurrentRole;
    },

  },
  data: function () {
    return {
      number_of_certificates:0,
      pupil_number: 23,
      female: 11,
      male: 12,
      average_grade: 4.32,
      passes_pupils: 21,
      transience: "98%",
      falling_pupils: 1,
      fall: "1%",
      absences: 543,
      justified: 538,
      unjustified: 5,
      months_hr: ["Siječanj", "Veljača", "Ožujak", "Travanj", "Svibanj", "Lipanj", "Srpanj", "Kolovoz", "Rujan", "Listopad", "Studeni", "Prosinac"],
      conductTitles:{
        '1':'Loše',
        '2':'Zadovoljavajuće',
        '3':'Dobro',
        '4':'Vrlo dobro',
        '5':'Uzorno',
      },

      readyToUse: false,
      showDonut: false,
      datacollection: null,
      graphTypes: [
        {text: "Ukupno", value: 0},
        {text: "Djelatnici", value: 1},
        {text: "Učenici", value: 2},
      ],
      stavke: [
        {
          maleFemaleRatio: {
            count: {},
          },
        },
        {
          percentagePassesRatio: {
            count: {},
          },
        },

      ],

      options: {
        chart: {
          id: "vuechart-example",
        },
        colors: ["rgba(0,67,121,0.7)"],
        labels: ["Odličan", "Vrlodobar", "Dobar", "Dovoljan", "Nedovoljan"],
        stroke: {
          show: true,
          width: 2,
          colors: ["rgba(0,67,121,0.9)"],
        },
        xaxis: {
          categories: [
            "Odličan",
            "Vrlodobar",
            "Dobar",
            "Dovoljan",
            "Nedovoljan",
          ],
        },
      },
      series: [
        {
          name: ["Broj učenika"],
          data: [],
        },
      ],

      options9: {
        chart: {
          id: "vuechart-example",
        },
        colors: ["rgba(0,67,121,0.7)"],
        labels: ["Odličan", "Vrlodobar", "Dobar", "Dovoljan", "Nedovoljan"],
        stroke: {
          show: true,
          width: 2,
          colors: ["rgba(0,67,121,0.9)"],
        },
        xaxis: {
          categories: [
            "Odličan",
            "Vrlodobar",
            "Dobar",
            "Dovoljan",
            "Nedovoljan",
          ],
        },
      },
      series9: [
        {
          name: ["Broj učenika"],
          data: [],
        },
      ],


      series8: [],
      chartOptions8: {
        chart: {
          type: "donut",
        },
        stroke: {
          colors: ["rgb(76,175,80)","rgba(228,0,43,0.7)" ],
        },

        colors: ["rgb(76,175,80)","rgba(228,0,43,0.9)" ],
        labels: [ "Prolazi","Pada"],
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
                horizontalAlign: "center",

                legend: {
                  position: "top",
                },
              },
            },
          },
        ],
      },

      options4: {
        chart: {
          id: "vuechart-example",
        },
        colors: ["rgba(0,67,121,0.7)"],
        labels: [],
        stroke: {
          show: true,
          width: 2,
          colors: ["rgba(0,67,121,0.9)"],
        },
        xaxis: {
          categories: [],
        },
      },
      series4: [
        {
          name: ["Broj učenika"],
          data: [],
        },
      ],

      options5: {
        chart: {
          id: "vuechart-example",
        },
        colors: ["rgba(228,0,43,0.9)"],
        labels: [],
        stroke: {
          show: true,
          width: 2,
          colors: ["rgba(228,0,43,0.7)"],
        },
        xaxis: {
          categories: [
            "Jedna negativna: ",
            "Dvije negativne: ",
            "Tri i više negativnih: ",
            "Neocijenjen (N): ",
          ],
        },
      },
      series5: [
        {
          name: ["Broj učenika"],
          data: [3, 2, 1, 1],
        },
      ],

      options6: {
        chart: {
          id: "vuechart-example",
        },
        colors: ["rgba(0,67,121,0.7)"],
        labels: [
        ],
        stroke: {
          show: true,
          width: 2,
          colors: ["rgba(0,67,121,0.9)"],
        },
        xaxis: {
          categories: [],
        },
      },
      series6: [
        {
          name: ["Broj:"],
          data: [],
        },
      ],

      options7: {
        chart: {
          id: "vuechart-example",
        },
        colors: ["rgb(76,175,80)"],
        labels: ["Uzorno", "Dobro", "Loše"],
        stroke: {
          show: true,
          width: 2,
          colors: ["rgb(76,175,80)"],
        },
        xaxis: {
          categories: [
            "Pohvala razrednika",
            "Pohvala razrednog vijeća",
            "POhvala učiteljskog vijeća",
          ],
        },
      },
      series7: [
        {
          name: ["Broj učenika"],
          data: [15, 3, 4],
        },
      ],

      series1: [
        {
          name: "Neobrađeni",
          data: [],
        },
        {
          name: "Neopravdani",
          data: [],
        },
        {
          name: "Opravdani",
          data: [],
        },
      ],
      chartOptions1: {
        chart: {
          type: "bar",
          height: 350,
        },
        colors: ["grey", "rgba(228,0,43,0.9)","rgba(0,67,121,0.7)",],
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "35%",
            endingShape: "rounded",
          },
        },
        dataLabels: {
          enabled: true,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["grey","rgba(228,0,43,0.7)","rgba(0,67,121,0.9)"],
        },
        xaxis: {
          categories: [],
        },
        fill: {
          opacity: 1,
          backgroundColor: "grey",
        },
      },
      series2: [
        {
          name: "Ukupno",
          data: [],
        },
        {
          name: "Djelatnici",
          data: [],
          color: "#000",
        },
        {
          name: "Učenici",
          data: [],
          color: "#F00",
        },
      ],

      chartOptions2: {
        chart: {
          height: 350,
          width: "auto",
          type: "line",
          zoom: {
            enabled: false,
          },
        },

        colors: ["#004379"],

        stroke: {
          curve: "straight",
        },

        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        xaxis: {
          categories: [],
        },
      },

      series3: [],
      chartOptions3: {
        chart: {
          type: "donut",
        },
        stroke: {
          colors: ["rgba(0,67,121,0.9)", "rgba(228,0,43,0.9)"],
        },

        colors: ["rgba(0,67,121,0.7)", "rgba(228,0,43,0.7)"],
        labels: ["Broj muških", "Broj ženskih"],
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
                horizontalAlign: "center",

                legend: {
                  position: "top",
                },
              },
            },
          },
        ],
      },
    };
  },
};
</script>

<style>
div.chart-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
